import { Button, FlexRow, ModalFooter } from 'components';
import {
  CheckboxInput,
  FormError,
  FormWrapper,
  NumberInput,
  SubmitButton
} from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
  item: MaterialToEditAmount;
  onSubmit: (values: EditAmountFormValues) => void;
  onCancel: () => void;
  allText: string;
}

export interface MaterialToEditAmount {
  materialId: string;
  amount?: number | null;
  maxAmount?: number | null;
}

export interface EditAmountFormValues {
  amount?: number | null;
  all: boolean;
}

interface EditAmountFormFieldsProps {
  item: MaterialToEditAmount;
  onCancel: () => void;
  allText: string;
}

const EditAmountFormFields = ({ item, onCancel, allText }: EditAmountFormFieldsProps) => {
  const { watch } = useFormContext<EditAmountFormValues>();
  const { t, tInput } = useCustomTranslation();
  const validators = useValidators();

  const all = watch('all');

  return (
    <>
      <NumberInput
        name="amount"
        disabled={all}
        min={0}
        label={t('material.amount')}
        max={item.maxAmount ? item.maxAmount : undefined}
        required
        options={{ required: validators.required }}
      />
      <CheckboxInput name="all" label={allText} />
      <FormError />
      <ModalFooter>
        <FlexRow noMargin>
          <Button onClick={onCancel}>{tInput('cancel_button')}</Button>
          <FlexRow noMargin>
            <SubmitButton />
          </FlexRow>
        </FlexRow>
      </ModalFooter>
    </>
  );
};

const EditAmountForm: React.FC<Props> = (props): React.ReactElement => {
  const { item, onSubmit, onCancel, allText } = props;

  const defaultValues: EditAmountFormValues = {
    all: item.amount === undefined || item.amount === item.maxAmount,
    amount: item.amount
  };

  return (
    <FormWrapper<EditAmountFormValues>
      className="EditAmountForm"
      defaultValues={defaultValues}
      onSubmit={(values) =>
        onSubmit({
          all: values.all,
          amount: values.all ? item.maxAmount : values.amount
        })
      }
    >
      <EditAmountFormFields item={item} onCancel={onCancel} allText={allText} />
    </FormWrapper>
  );
};

export default EditAmountForm;
